module.exports = __webpack_public_path__ + "static/media/default-cover.bd3370c2.png";